export default "__VITE_PUBLIC_ASSET__7f8ce4d0__"